export default "__VITE_ASSET__DlnRNtYh__"